<div>
  <button mat-raised-button color="primary" (click)="markAllSeen()">mark all seen</button>
</div>
